import React, { useContext } from 'react';
import { ImageCropperContext } from '../../../libs/gs-component-image-upload';
import { TripleAction } from '../../../libs/gs-component-right-rail';

import styles from './index.scss';

interface Props {
  onCancel: () => void;
  primaryActionText?: string;
  secondaryActionText?: string;
}

const CropperPhotoActions: React.FC<Props> = ({
  onCancel,
  primaryActionText = 'Upload Photo',
  secondaryActionText = 'Discard Photo',
}) => {
  const { saveImage } = useContext(ImageCropperContext);
  const cancelAndPreventDefault = (e: any) => {
    e.preventDefault();
    onCancel();
  };
  const saveAndPreventDefault = (e: any) => {
    e.preventDefault();
    saveImage();
  };

  return (
    <TripleAction
      className={styles.buttonWrap}
      secondaryText={secondaryActionText}
      secondaryOnClick={cancelAndPreventDefault}
      primaryText={primaryActionText}
      primaryOnClick={saveAndPreventDefault}
    />
  );
};

export default CropperPhotoActions;
